import { useQuery } from '@apollo/client';

import { useAccountCompanyId } from 'application/hooks';

import useCompanyCreateAmoTaskToBill from 'domain/billing/useCompanyCreateAmoTaskToBill';
import { AuthCurrentUserQuery, AuthCurrentUserDocument } from 'domain/api/graphql/generated';
import { FetchPolicyKeys } from 'domain/api/graphql/types';

import { UseInvoiceRequestViewModel } from './types';

const useInvoiceRequestPresenter = (): UseInvoiceRequestViewModel => {
  const companyId = useAccountCompanyId();

  const { data } = useQuery<AuthCurrentUserQuery>(AuthCurrentUserDocument, {
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  const currentCompany = data?.currentUserPureQuery?.mainCompany;

  const { request: companyCreateAmoTaskToBill, loading } = useCompanyCreateAmoTaskToBill();

  const paymentByInvoiceRequest = async () => {
    const isOk = await companyCreateAmoTaskToBill(companyId);

    return isOk;
  };

  return {
    isPaymentByInvoiceRequested: Boolean(currentCompany?.isPaymentByInvoiceRequested),
    isPaymentRequestLoading: loading,
    paymentByInvoiceRequest,
  };
};

export default useInvoiceRequestPresenter;
